<!-- ALERT TOAST-->
<p-toast></p-toast>
<!-- CONFIRMATION DIALOG-->
<p-confirmDialog [style]="{width: '50vw'}">

</p-confirmDialog>
<!-- OVERLAY SCREEN-->
<div *ngIf="blocked" class="overlay">
    <img src="assets/layout/images/tovlogo.png" alt="Loading Icon" class="loading-image" />
    <span style="color: white; font-size: large;">{{lbl_loading}}</span>
</div>

<p-fieldset>

    <ng-template pTemplate="header"></ng-template>
    <!-- GO BACK -->
    <p-toolbar styleClass="p-mb-4">
        <ng-template pTemplate="left">
            <button pButton pRipple label="{{lbl_go_Back}}" icon="pi pi-chevron-left" class="p-button-warning p-mr-2"
                (click)="goBack()"></button>
        </ng-template>
    </p-toolbar>

    <!-- Main Card -->
    <div class="card">
        <!-- Tab View-->
        <p-tabView>
            <p-tabPanel header="Conceptos FII" [selected]="true">
                <!-- 1st Section -->
                <div class="p-grid">
                    <div class="p-col-12 p-md-12">
                        <div class="p-fluid">
                            <!-- Input Change-->
                            <div class="p-fluid">
                                <div class="p-grid">
                                    <!-- Input -->
                                    <div class="p-col-12 p-md-6">
                                        <label for="conType">
                                            Tipo de FII:</label>
                                        <input type="text" pInputText id="conType" [(ngModel)]="fiiConceptsTemp.conType"
                                            required autofocus [disabled]="opt === 'U' ? true : false" maxlength="1" />
                                        <small class="p-error" *ngIf="submitted && !fiiConceptsTemp.conType">Tipo
                                            es
                                            requerido</small>
                                    </div>

                                    <!-- Input -->
                                    <div class="p-col-12 p-md-6">
                                        <label for="concepId">
                                            Identificador de FII:</label>
                                        <input type="text" pInputText id="concepId"
                                            [(ngModel)]="fiiConceptsTemp.concepId" required autofocus
                                            [disabled]="opt === 'U' ? true : false" maxlength="3" />
                                        <small class="p-error"
                                            *ngIf="submitted && !fiiConceptsTemp.concepId">Identificador
                                            es
                                            requerido</small>
                                    </div>

                                </div>
                            </div>
                            <div class="p-grid">

                                <!-- Input -->
                                <div class="p-col-12 p-md-6">
                                    <label for="descripTmp">
                                        Descripción de FII:</label>
                                    <input type="text" pInputText id="descripTmp" [(ngModel)]="fiiConceptsTemp.descrip"
                                        required autofocus maxlength="60" />
                                    <small class="p-error" *ngIf="submitted && !fiiConceptsTemp.descripTmp">Descripción
                                        es
                                        requerido</small>
                                </div>
                                <!-- Input -->
                                <div class="p-col-12 p-md-6">
                                    <label for="shrDescTmp">
                                        Nombre corto de FII:</label>
                                    <input type="text" pInputText id="shrDescTmp" [(ngModel)]="fiiConceptsTemp.shrDesc"
                                        required autofocus maxlength="37" />
                                    <small class="p-error" *ngIf="submitted && !fiiConceptsTemp.shrDescTmp">Descripción
                                        es
                                        requerido</small>
                                </div>
                            </div>

                            <div class="p-grid">
                                <!-- Input -->
                                <div class="p-col-12 p-md-6" *ngIf="fiiConceptsTemp.visList">
                                    <label for="visList">
                                        VIS de FII:</label>
                                    <p-multiSelect [options]="visList" [(ngModel)]="fiiConceptsTemp.visList"
                                        defaultLabel="Seleccione AUT" optionLabel="label"
                                        selectedItemsLabel="{0} items selected" inputId="aut"></p-multiSelect>
                                    <small class="p-error" *ngIf="submitted && !fiiConceptsTemp.visList">VIS es
                                        requerido</small>
                                </div>

                                <!-- Input -->
                                <div class="p-col-12 p-md-6" *ngIf="fiiConceptsTemp.autList">
                                    <label for="autList">
                                        AUT de FII:</label>
                                    <p-multiSelect [options]="autList" [(ngModel)]="fiiConceptsTemp.autList"
                                        defaultLabel="Seleccione AUT" optionLabel="label"
                                        selectedItemsLabel="{0} items selected" inputId="aut"></p-multiSelect>
                                    <small class="p-error" *ngIf="submitted && !fiiConceptsTemp.autList">VIS es
                                        requerido</small>
                                </div>
                            </div>
                        </div>
                        <!-- Section Button -->
                        <br />
                        <div class="p-grid">
                            <div class="p-col-12 p-md-6" style="text-align: end;">
                            </div>
                            <div class="p-col-12 p-md-6" style="text-align: end;">
                                <button pButton pRipple label="Guardar / Actualizar FII" icon="pi pi-plus"
                                    class="p-button-success" (click)="saveFiiConcepts()" style="width: 50%;"></button>
                            </div>
                        </div>
                    </div>
                </div>
            </p-tabPanel>
            <p-tabPanel *ngIf="opt == 'U'" header="Lenguajes FII">
                <!-- 2nd Section -->
                <div class="p-grid">

                    <div class="p-col-12 p-md-12">
                        <div class="p-fluid" [formGroup]="langForm">
                            <div class="p-grid">
                                <!-- Input -->
                                <div class="p-col-12 p-md-4">
                                    <label for="data_language">
                                        Traducción de FII:</label>
                                    <p-dropdown [options]="languagesLstGlobal" formControlName="data_language"
                                        optionLabel="value" [showClear]="true"
                                        placeholder="Seleccione traducción"></p-dropdown>
                                </div>

                                <!-- Input -->
                                <div class="p-col-12 p-md-4">
                                    <label for="data_desc">
                                        Descripción de FII:</label>
                                    <input type="text" pInputText id="data_desc" formControlName="data_desc" required
                                        autofocus />
                                </div>
                                <!-- Input -->
                                <div class="p-col-12 p-md-4">
                                    <label for="data_shr">
                                        Nombre corto de FII:</label>
                                    <input type="text" pInputText id="data_shr" formControlName="data_shr" required
                                        autofocus />
                                </div>
                            </div>
                        </div>
                        <div class="p-fluid">
                            <p-table *ngIf="languagesLst" [value]="languagesLst" editMode="row" responsive="true"
                                dataKey="id.language">
                                <ng-template pTemplate="header">
                                    <tr>
                                        <th>Concepto</th>
                                        <th>Lenguaje</th>
                                        <th>Descripción</th>
                                        <th>Descripción Corta</th>
                                        <th>Editar</th>
                                    </tr>
                                </ng-template>
                                <ng-template pTemplate="body" let-language let-editing="editing">
                                    <tr [pEditableRow]="language">
                                        <td>
                                            {{ language.id.concepId}}
                                        </td>
                                        <td>
                                            {{ language.id.language}}
                                        </td>
                                        <td>
                                            <p-cellEditor>
                                                <ng-template pTemplate="input">
                                                    <input pInputText type="text" [(ngModel)]="language.descrip"
                                                        maxlength="60">
                                                </ng-template>
                                                <ng-template pTemplate="output">
                                                    {{ language.descrip}}
                                                </ng-template>
                                            </p-cellEditor>
                                        </td>
                                        <td>
                                            <p-cellEditor>
                                                <ng-template pTemplate="input">
                                                    <input pInputText type="text" [(ngModel)]="language.shrDesc"
                                                        maxlength="37">
                                                </ng-template>
                                                <ng-template pTemplate="output">
                                                    {{ language.shrDesc}}
                                                </ng-template>
                                            </p-cellEditor>
                                        </td>
                                        <td style="text-align:center">
                                            <button *ngIf="!editing" pButton pRipple type="button" pInitEditableRow
                                                icon="pi pi-pencil" (click)="onRowEditInit(language)"
                                                class="p-button-rounded p-button-text"></button>
                                            <button *ngIf="editing" pButton pRipple type="button" pSaveEditableRow
                                                icon="pi pi-check" (click)="onRowEditSave(language)"
                                                class="p-button-rounded p-button-text p-button-success p-mr-2"></button>
                                            <button *ngIf="editing" pButton pRipple type="button" pCancelEditableRow
                                                icon="pi pi-times" (click)="onRowEditCancel(language)"
                                                class="p-button-rounded p-button-text p-button-danger"></button>
                                            <button pButton pRipple type="button" icon="pi pi-trash"
                                                (click)="onRowEditDelete(language)"
                                                class="p-button-rounded p-button-text p-button-danger p-mr-2"></button>

                                        </td>
                                    </tr>
                                </ng-template>
                            </p-table>

                        </div>
                        <!-- Section Button -->
                        <br />
                        <div class="p-grid">
                            <div class="p-col-12 p-md-6" style="text-align: end;">
                            </div>
                            <div class="p-col-12 p-md-6" style="text-align: end;">
                                <button pButton label="Guardar" icon="pi pi-plus" class="p-button-success"
                                    (click)="saveFiiLanguage()" style="width: 50%;"></button>
                            </div>
                        </div>
                    </div>
                </div>
            </p-tabPanel>
        </p-tabView>
    </div>
</p-fieldset>